export const AppConstants = {
  PowerUnitHash: "hash",
  PowerUnitCpd: "cpd",
  PowerHash: 6,
  PowerCPD: -3,
  PoolName: "ZULUPooL",
  PoolSite: "ZULUPOOL.com",
  SessionId: "sessionId",
  PoolCreationDate: 1_606_424_400,
  PageInfoLoadInterval: 60,
  FoundBlocksLoadInterval: 600,
  PrimaryGuy: "admin",
  SecondaryGuy: "observer",
  Locale: "lcl",
  DomainRu: "ru",
  DomainCom: "com"
};
